import React from "react";
import ReactDOM from "react-dom";
import { isMobile } from "react-device-detect";
import { Tooltip } from "react-tippy";
import Modal from "react-responsive-modal";
import classNames from "classnames";

class MultiImagePicker extends React.Component {
  constructor(props) {
    super();
    this.state = {
      fromSources: "file facebook instagram dropbox url",
      images_to_save: [],
      undersizedImages: false,
    };
    this.pushImageIntoState = this.pushImageIntoState.bind(this);
    this.sizeWarning = this.sizeWarning.bind(this);
    this.saveToDatabase = this.saveToDatabase.bind(this);
    this.saveSuccess = this.saveSuccess.bind(this);
    this.saveFail = this.saveFail.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    var myWidget = window.cloudinary.createUploadWidget(
      {
        cloudName: "framefox",
        uploadPreset: "framefox_default",
        showPoweredBy: false,
        autoMinimize: false,
        showAdvancedOptions: false,
        maxFileSize: 200000000,
        validateMaxWidthHeight: true,
        maxImageWidth: 10000,
        maxImageHeight: 10000,
        resourceType: "image",
        sources: [
          "local",
          "url",
          "camera",
          "google_drive",
          "dropbox",
          "instagram",
          "unsplash",
          "facebook",
        ],
        multiple: true,
        defaultSource: "local",
        styles: {
          palette: {
            window: "#FFFFFF",
            windowBorder: "#222",
            tabIcon: "#222",
            menuIcons: "#222",
            textDark: "#000000",
            textLight: "#FFFFFF",
            link: "#222",
            action: "#F8F6F0",
            inactiveTabIcon: "#4A3B33",
            error: "#F44235",
            inProgress: "#222",
            complete: "#222",
            sourceBg: "#FFFFFF",
          },
          fonts: {
            default: null,
            "'Figtree', sans-serif": {
              url: "https://fonts.googleapis.com/css?family=Figtree",
              active: true,
            },
          },
        },
      },
      (error, result) => {
        if (!error && result && result.event === "success") {
          this.pushImageIntoState(result.info);
        } else if (!error && result && result.event === "close") {
          this.saveToDatabase();
        }
      }
    );

    this.setState({ widget: myWidget });
  }

  pushImageIntoState(data) {
    const newImage = {
      width: data.width,
      height: data.height,
      filename: data.original_filename,
      external_id: data.public_id,
      host: "cloudinary",
      path: "path",
      source: "direct",
      url: data.secure_url,
      filesize: data.bytes,
      format: data.format,
    };

    if (this.sizeWarning(newImage)) {
      this.setState({ undersizedImages: true });
    }
    var joined = this.state.images_to_save.concat(newImage);
    this.setState({ images_to_save: joined });
  }

  sizeWarning(newImage) {
    let dpih = newImage.height / this.props.big_frame_height;
    let dpiw = newImage.width / this.props.big_frame_width;
    if (Math.min(dpih, dpiw) < 90) {
      return true;
    }
  }

  saveToDatabase() {
    $.ajax({
      method: "PATCH",
      url: this.props.post_image_url,
      data: {
        selection: {
          id: this.props.selection_id,
          images_attributes: this.state.images_to_save,
        },
      },
    })
      .done(this.saveSuccess)
      .fail(this.saveFail);
  }

  saveSuccess(data) {
    this.setState({ images_to_save: [] });
    this.props.onImagesUploaded(data.images);
  }

  saveFail() {
    console.log("Failed to save");
  }

  closeModal() {
    this.setState({ undersizedImages: false });
  }

  render() {
    return (
      <div
        className={classNames(
          "tray-button",
          this.props.deleteImageMode && "deleteImageMode"
        )}
      >
        <Tooltip
          title={`👇 ${
            !isMobile ? "Click here or drag & drop" : "Tap here"
          } to upload files`}
          open={true}
          arrow={true}
          position="top"
          distance={30}
          open={this.props.showTooltip}
        >
          {!this.props.deleteImageMode && (
            <button
              id="upload_widget"
              onClick={() => {
                this.state.widget.open();
              }}
              className="btn my-4 btn-primary btn-sm"
            >
              <i className="fa-solid fa-arrow-up-from-bracket mr-2" />
              <span className="hidden md:inline">Upload photos</span>
            </button>
          )}
        </Tooltip>
        {!this.props.trayIsOpen &&
          this.props.images &&
          this.props.images.length > 0 && (
            <button
              className={classNames(
                "text-sm hidden md:block mx-auto",
                this.props.deleteImageMode
                  ? "btn btn-secondary px-8"
                  : "text-brand-500 underline"
              )}
              onClick={this.props.toggleDeleteImageMode}
            >
              {this.props.deleteImageMode ? "Done" : "Edit"}
            </button>
          )}
        <Modal
          open={this.state.undersizedImages}
          onClose={function () {}}
          classNames={{
            overlay: "custom-overlay",
            modal: "custom-modal small",
          }}
        >
          <div className="text-center">
            <h3 className="font-weight-bold">
              <i className="fa-solid fa-triangle-exclamation text-red-600"></i>{" "}
              Whoops!
            </h3>
            <p className="lead">
              The resolution of one or more of your photos is too low for us to
              ensure a high-quality print.
            </p>
            <div
              className="btn btn-primary btn-lg mt-3"
              onClick={this.closeModal}
            >
              OK
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default MultiImagePicker;
